module.exports = __webpack_public_path__ + "images/jinbi.1730859054743.png";